<figure class="infographics">
    <h1>{{header}}</h1>
    <div class="ct-chart"></div>
    <figcaption>{{caption}}</figcaption>
</figure>


